// extracted by mini-css-extract-plugin
export default {"form":"AuthForm_form__uCE2H","form_active":"AuthForm_form_active__O7g7V","title":"AuthForm_title__JZyeQ","button":"AuthForm_button__U6ALn"};